/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/
"use strict";

var $protobuf = require("protobufjs/minimal");

// Common aliases
var $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;

// Exported root namespace
var $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

$root.PullRequest = (function() {

    /**
     * Properties of a PullRequest.
     * @exports IPullRequest
     * @interface IPullRequest
     * @property {string|null} [guid] PullRequest guid
     * @property {number|null} [version] PullRequest version
     * @property {string|null} [fromGuid] PullRequest fromGuid
     * @property {string|null} [targetGuid] PullRequest targetGuid
     * @property {string|null} [lastMsgGuid] PullRequest lastMsgGuid
     * @property {PullRequest.PullType|null} [pullType] PullRequest pullType
     */

    /**
     * Constructs a new PullRequest.
     * @exports PullRequest
     * @classdesc Represents a PullRequest.
     * @implements IPullRequest
     * @constructor
     * @param {IPullRequest=} [properties] Properties to set
     */
    function PullRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * PullRequest guid.
     * @member {string} guid
     * @memberof PullRequest
     * @instance
     */
    PullRequest.prototype.guid = "";

    /**
     * PullRequest version.
     * @member {number} version
     * @memberof PullRequest
     * @instance
     */
    PullRequest.prototype.version = 0;

    /**
     * PullRequest fromGuid.
     * @member {string} fromGuid
     * @memberof PullRequest
     * @instance
     */
    PullRequest.prototype.fromGuid = "";

    /**
     * PullRequest targetGuid.
     * @member {string} targetGuid
     * @memberof PullRequest
     * @instance
     */
    PullRequest.prototype.targetGuid = "";

    /**
     * PullRequest lastMsgGuid.
     * @member {string} lastMsgGuid
     * @memberof PullRequest
     * @instance
     */
    PullRequest.prototype.lastMsgGuid = "";

    /**
     * PullRequest pullType.
     * @member {PullRequest.PullType} pullType
     * @memberof PullRequest
     * @instance
     */
    PullRequest.prototype.pullType = 0;

    /**
     * Creates a new PullRequest instance using the specified properties.
     * @function create
     * @memberof PullRequest
     * @static
     * @param {IPullRequest=} [properties] Properties to set
     * @returns {PullRequest} PullRequest instance
     */
    PullRequest.create = function create(properties) {
        return new PullRequest(properties);
    };

    /**
     * Encodes the specified PullRequest message. Does not implicitly {@link PullRequest.verify|verify} messages.
     * @function encode
     * @memberof PullRequest
     * @static
     * @param {IPullRequest} message PullRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PullRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.guid != null && message.hasOwnProperty("guid"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.guid);
        if (message.version != null && message.hasOwnProperty("version"))
            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.version);
        if (message.fromGuid != null && message.hasOwnProperty("fromGuid"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.fromGuid);
        if (message.targetGuid != null && message.hasOwnProperty("targetGuid"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.targetGuid);
        if (message.lastMsgGuid != null && message.hasOwnProperty("lastMsgGuid"))
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.lastMsgGuid);
        if (message.pullType != null && message.hasOwnProperty("pullType"))
            writer.uint32(/* id 6, wireType 0 =*/48).int32(message.pullType);
        return writer;
    };

    /**
     * Encodes the specified PullRequest message, length delimited. Does not implicitly {@link PullRequest.verify|verify} messages.
     * @function encodeDelimited
     * @memberof PullRequest
     * @static
     * @param {IPullRequest} message PullRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PullRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a PullRequest message from the specified reader or buffer.
     * @function decode
     * @memberof PullRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {PullRequest} PullRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PullRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.PullRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.guid = reader.string();
                break;
            case 2:
                message.version = reader.int32();
                break;
            case 3:
                message.fromGuid = reader.string();
                break;
            case 4:
                message.targetGuid = reader.string();
                break;
            case 5:
                message.lastMsgGuid = reader.string();
                break;
            case 6:
                message.pullType = reader.int32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a PullRequest message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof PullRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {PullRequest} PullRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PullRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a PullRequest message.
     * @function verify
     * @memberof PullRequest
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    PullRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.guid != null && message.hasOwnProperty("guid"))
            if (!$util.isString(message.guid))
                return "guid: string expected";
        if (message.version != null && message.hasOwnProperty("version"))
            if (!$util.isInteger(message.version))
                return "version: integer expected";
        if (message.fromGuid != null && message.hasOwnProperty("fromGuid"))
            if (!$util.isString(message.fromGuid))
                return "fromGuid: string expected";
        if (message.targetGuid != null && message.hasOwnProperty("targetGuid"))
            if (!$util.isString(message.targetGuid))
                return "targetGuid: string expected";
        if (message.lastMsgGuid != null && message.hasOwnProperty("lastMsgGuid"))
            if (!$util.isString(message.lastMsgGuid))
                return "lastMsgGuid: string expected";
        if (message.pullType != null && message.hasOwnProperty("pullType"))
            switch (message.pullType) {
            default:
                return "pullType: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
                break;
            }
        return null;
    };

    /**
     * Creates a PullRequest message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof PullRequest
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {PullRequest} PullRequest
     */
    PullRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.PullRequest)
            return object;
        var message = new $root.PullRequest();
        if (object.guid != null)
            message.guid = String(object.guid);
        if (object.version != null)
            message.version = object.version | 0;
        if (object.fromGuid != null)
            message.fromGuid = String(object.fromGuid);
        if (object.targetGuid != null)
            message.targetGuid = String(object.targetGuid);
        if (object.lastMsgGuid != null)
            message.lastMsgGuid = String(object.lastMsgGuid);
        switch (object.pullType) {
        case "UNKNOWN":
        case 0:
            message.pullType = 0;
            break;
        case "HISTORY":
        case 1:
            message.pullType = 1;
            break;
        case "OFFLINE":
        case 2:
            message.pullType = 2;
            break;
        case "MSGBUFFER":
        case 3:
            message.pullType = 3;
            break;
        case "MSG_READ_STATUS":
        case 4:
            message.pullType = 4;
            break;
        }
        return message;
    };

    /**
     * Creates a plain object from a PullRequest message. Also converts values to other types if specified.
     * @function toObject
     * @memberof PullRequest
     * @static
     * @param {PullRequest} message PullRequest
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    PullRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.guid = "";
            object.version = 0;
            object.fromGuid = "";
            object.targetGuid = "";
            object.lastMsgGuid = "";
            object.pullType = options.enums === String ? "UNKNOWN" : 0;
        }
        if (message.guid != null && message.hasOwnProperty("guid"))
            object.guid = message.guid;
        if (message.version != null && message.hasOwnProperty("version"))
            object.version = message.version;
        if (message.fromGuid != null && message.hasOwnProperty("fromGuid"))
            object.fromGuid = message.fromGuid;
        if (message.targetGuid != null && message.hasOwnProperty("targetGuid"))
            object.targetGuid = message.targetGuid;
        if (message.lastMsgGuid != null && message.hasOwnProperty("lastMsgGuid"))
            object.lastMsgGuid = message.lastMsgGuid;
        if (message.pullType != null && message.hasOwnProperty("pullType"))
            object.pullType = options.enums === String ? $root.PullRequest.PullType[message.pullType] : message.pullType;
        return object;
    };

    /**
     * Converts this PullRequest to JSON.
     * @function toJSON
     * @memberof PullRequest
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    PullRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * PullType enum.
     * @name PullRequest.PullType
     * @enum {string}
     * @property {number} UNKNOWN=0 UNKNOWN value
     * @property {number} HISTORY=1 HISTORY value
     * @property {number} OFFLINE=2 OFFLINE value
     * @property {number} MSGBUFFER=3 MSGBUFFER value
     * @property {number} MSG_READ_STATUS=4 MSG_READ_STATUS value
     */
    PullRequest.PullType = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "UNKNOWN"] = 0;
        values[valuesById[1] = "HISTORY"] = 1;
        values[valuesById[2] = "OFFLINE"] = 2;
        values[valuesById[3] = "MSGBUFFER"] = 3;
        values[valuesById[4] = "MSG_READ_STATUS"] = 4;
        return values;
    })();

    return PullRequest;
})();

module.exports = $root;
